import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-key-failed',
  templateUrl: './e-key-failed.component.html',
  standalone:false,
  styleUrls: ['./e-key-failed.component.scss']
})
export class EKeyFailedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
